import { createReducer, on } from '@ngrx/store';

import {
  fetchFlightsOptionForPackageUpsellAction,
  fetchPackageUpsellOptionsAction,
  fetchUpsellOptionsAction,
  fetchUpsellOptionsBySectorAction,
  fetchUpsellOptionsForDesktopAction,
  fetchUpsellOptionsForPackageUpsellForDesktopAction
} from '@upsell/store/actions/upsell.actions';
import { UpsellPayload } from '@upsell/entities/upsell-payload';

export const initialState: UpsellPayload = {} as UpsellPayload;

export const upsellPayloadReducer = createReducer(
  initialState,
  on(fetchUpsellOptionsAction, (state, { optionId, searchId, sessionToken }) => {
    return {
      optionId, searchId, sessionToken
    } as UpsellPayload;
  }),
  on(fetchUpsellOptionsBySectorAction, (state, { optionId, searchId, sessionToken }) => {
    return {
      optionId, searchId, sessionToken
    } as UpsellPayload;
  }),
  on(fetchUpsellOptionsForDesktopAction, (state, { optionId, searchId, sessionToken }) => {
    return {
      optionId, searchId, sessionToken
    } as UpsellPayload;
  }),
  on(fetchUpsellOptionsBySectorAction, (state, { optionId, searchId, sessionToken }) => {
    return {
      optionId, searchId, sessionToken
    } as UpsellPayload;
  }),
  on(fetchUpsellOptionsForPackageUpsellForDesktopAction, (state, { upsell, payload }) => {
    return {
      optionId: Number(upsell.optionIdAir), searchId: upsell.SearchId, sessionToken: upsell.SessionToken
    } as UpsellPayload;
  }),
  on(fetchPackageUpsellOptionsAction, (state, { payload }) => {
    return {
      optionId: Number(payload.optionIdAir),
      searchId: payload.SearchId,
      sessionToken: payload.SessionToken,
      packageHotelOptionId: Number(payload.hotelOptionId),
      packageHotelRateId: payload.rateId
    } as UpsellPayload;
  }),
  on(fetchFlightsOptionForPackageUpsellAction, (state, { upsell }) => {
    return {
      optionId: Number(upsell.optionIdAir),
      searchId: upsell.SearchId,
      sessionToken: upsell.SessionToken,
      packageHotelOptionId: Number(upsell.hotelOptionId),
      packageHotelRateId: upsell.rateId
    } as UpsellPayload;
  })
);
